import Typography from 'components/commercetools-ui/atoms/typography';
import Link from 'components/commercetools-ui/atoms/link';
import Markdown from '../markdown';
import { WarrantyProps } from './types';

const Warranty = ({ warranty }: WarrantyProps) => {
const warrantyDeails = warranty?.sections?.find(
    (section: any) => section?.info_section_with_image
  )?.info_section_with_image || '';
  const cmsCssClass = warranty?.sections?.find(
    (section: any) => section?.info_section_with_image?.additional_css
  )?.info_section_with_image.additional_css || warranty?.additional_css;

  //console.log('warrantyDeails', warrantyDeails);
 if (!warrantyDeails) return null;
  return (
    <>
      <div className="mt-10 pl-24 pt-4 mb-0 overflow-hidden md:px-28 lg:px-48 xl:px-60 pt-48 2xl:px-80 xl:pt-60 2xl:pt-80">
      <div className={`some-default-class ${cmsCssClass || ''}`}>
        {warrantyDeails?.title && (
          <div className="">
            <Typography className="text-center text-2xl font-medium md:text-5xl">{warrantyDeails?.title}</Typography>
          </div>
        )}

        {warrantyDeails?.description && (
          <Markdown
            markdown={warrantyDeails?.description}
            className="pt-32 text-16 font-normal leading-6 text-[#333] lg:text-14 2xl:text-20 2xl:leading-8"
          />
        )}
        <div className="mt-16 mb-0 flex flex-wrap gap-8 items-center">
  {warrantyDeails?.content_with_icon?.map((images: any, index: number) => (
    <Link link={images.link} target="_blank" rel="noopener noreferrer" key={index} className="flex-1 min-w-[100px] max-w-[150px] md:max-w-[150px] lg:max-w-[150px]">
      <img
        loading="lazy"
        srcSet={images?.icon?.url}
        alt={`Image ${index + 1}`}
        className="my-auto w-full object-contain h-auto"
      />
    </Link>
  ))}
</div>

      </div>
      </div>
    </>
  );
};

export default Warranty;
